import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiArrowRight } from 'react-icons/fi';
import { Icon } from '../ui/Icon';

const navItems = [
  { to: '/offres', label: 'Offres' },
  { to: '/comparatif-offres', label: 'Comparatif' },
  { to: '/faq', label: 'FAQ' },
  { to: '/a-propos', label: 'À propos' },
] as const;

export function Header() {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header className="border-b border-white/10 bg-zinc-950/70 backdrop-blur">
      <div className="lbf-container flex h-16 items-center justify-between gap-4">
        <NavLink to="/" className="flex items-center gap-3">
          <img
            src="/images/logo.webp"
            width={36}
            height={36}
            alt="LuckyBetFR"
            className="h-12 w-auto rounded-xl border border-white/10 bg-white/5"
            decoding="async"
          />
          <div className="leading-tight">
            <div className="text-sm font-extrabold tracking-wide">LuckyBetFR</div>
            <div className="text-[11px] text-zinc-300/80">Paris sportifs • Bonus • Retraits</div>
          </div>
        </NavLink>

        <nav className="hidden items-center gap-1 md:flex" aria-label="Navigation principale">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  'rounded-xl px-3 py-2 text-sm font-semibold transition',
                  isActive ? 'bg-white/5 text-white' : 'text-white/80 hover:bg-white/5 hover:text-white',
                ].join(' ')
              }
            >
              {item.label}
            </NavLink>
          ))}
          <NavLink to="/offres" className="lbf-btn-primary ml-2">
            Top bonus <Icon icon={FiArrowRight} className="text-base" aria-hidden="true" />
          </NavLink>
        </nav>

        <button
          type="button"
          className="lbf-btn-ghost md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls="mobile-menu"
        >
          {open ? (
            <Icon icon={FiX} className="text-lg" aria-hidden="true" />
          ) : (
            <Icon icon={FiMenu} className="text-lg" aria-hidden="true" />
          )}
          <span className="sr-only">Menu</span>
        </button>
      </div>

      {open ? (
        <div id="mobile-menu" className="border-t border-white/10 bg-zinc-950/95 md:hidden">
          <div className="lbf-container py-3">
            <div className="grid gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    [
                      'rounded-xl px-3 py-2 text-sm font-semibold transition',
                      isActive ? 'bg-white/5 text-white' : 'text-white/80 hover:bg-white/5 hover:text-white',
                    ].join(' ')
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <NavLink to="/offres" className="lbf-btn-primary mt-2">
                Comparer les offres <Icon icon={FiArrowRight} className="text-base" aria-hidden="true" />
              </NavLink>
            </div>
          </div>
        </div>
      ) : null}
    </header>
  );
}


